export default "__VITE_ASSET__qquuaS8f__"